import ReqClient from './request.class'
import axios from 'axios'
import { HOST_API } from './config'

export async function queryAllProjectGroup(data) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/queryAllProjectGroup',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
export async function queryProjectGroupById(params) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/queryProjectGroup',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function queryAllPtomStaff(params) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/queryAllPtomStaff',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function addOrEditProjectGroup(data) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/editProjectGroup',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function queryAllGameByCondition(data) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/queryAllGameByCondition',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function editProjectGroupGame(data) {
  const Req = new ReqClient({
    url: '/api/ptom/projectGroup/editProjectGroupGame',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建天工应用
export async function buildAggregationApp(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/buildAggregationApp',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 综合应用获取接入数据
export async function queryAggregationAccessInfo(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryAggregationAccessInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 聚合渠道应用接入数据
export async function queryAggregationChannelAccessInfo(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryAggregationChannelAccessInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改综合应用接入状态
export async function passAccessStateByMGameId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/passAccessStateByMGameId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改聚合渠道应用接入状态
export async function passAccessStateByDevGameId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/passAccessStateByDevGameId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取渠道配置信息
export async function getChannelConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/getChannelConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 聚合列表-返回拥有权限的游戏信息
export async function queryALLGameByAuth(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryALLGameByAuth',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取全部插件信息
export async function queryAllSdkPlugin(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryAllSdkPlugin',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取全部应用渠道信息
export async function getAllAppChannelInfo(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/getAllAppChannelInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 综合-上传母包
export async function uploadParentPackage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/uploadParentPackage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 聚合-上传渠道母包
export async function uploadChannelPackage(data) {
  return axios({
    url: HOST_API + '/api/ptom/aggregation/uploadChannelPackage',
    data: data,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  })
}

// 修改媒体配置
export async function addOrUpdateAppinfoMedia(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/addOrUpdateAppinfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 打包
export async function channelPackByConfigId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/channelPackByConfigId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改应用信息
export async function updateAggregationApp(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/updateAggregationApp',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新安卓渠道配置信息
export async function updataChannelConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/updataChannelConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新IOS渠道配置信息
export async function updataIosChannelConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/updataIosChannelConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传图片/文件
export async function uploadAppImage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/uploadAppImage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据游戏ID查找应用媒体配置信息
export async function findAppInfoById(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/findAppInfoById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 综合界面查询
export async function queryAggregationAppByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryAggregationAppByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 聚合界面查询
export async function queryChannelAggregationAppByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryChannelAggregationAppByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建天工渠道应用
export async function buildChannelAggregationApp(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/buildChannelAggregationApp',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除天工应用
export async function deleteAggregationApp(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/deleteAggregationApp',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除天工渠道应用
export async function deleteChannelAggregationApp(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/deleteChannelAggregationApp',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取全部渠道信息
export async function queryAllChannel(data) {
  const Req = new ReqClient({
    url: '/api/ptom/aggregation/queryAllChannel',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取标签
export async function getTag(params) {
  const Req = new ReqClient({
    url: '/api/ptom/type/label/queryById',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号列表
export async function queryAccountList(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/queryAccountPage',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新账号状态
export async function updateAccountStatus(params) {
  const Req = new ReqClient({
    url: 'api/ptom/adAccount/updateStatus',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量更新账号状态
export async function batchUpdateAccountStatus(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/batchUpdateStatus',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量导入账号
export async function batchImportAccountData(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/importData',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号自动禁用配置
export async function getSpiderMonitorConfig() {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/getSpiderMonitorConfig',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 设置账号自动禁用配置
export async function setSpiderMonitorConfig(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/setSpiderMonitorConfig',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 设置媒体素材管理账号
export async function updateImageUploadManageAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/batchUpdateImageUploadManage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取媒体素材管理账号
export async function getImageUploadManageAccountConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/queryImageUploadManage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导入账号清理任务文件
export async function importClearAccountsFile(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/importAccountClear',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取账号自动禁用配置
export async function accountDisableTrigger() {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/trigger',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增账号
export async function addAccount(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/add',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑账号
export async function editAccount(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/edit',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取公司主体
export async function queryCompanyList() {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/listByCompanyiifo',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除公司主体
export async function deleteCompanyBody(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/deleteByCompanyiifo',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建公司主体
export async function addCompanyBody(params) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/addCompanyiifo',
    method: 'POST',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * 成员配置模块
 */
// 查询用户列表
export async function queryUsersApi(data) {
  const Req = new ReqClient({
    url: '/api/user/queryUsers',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加用户
export async function addUserApi(data) {
  const Req = new ReqClient({
    url: '/api/user/addUser',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑用户
export async function updateUserApi(data) {
  const Req = new ReqClient({
    url: '/api/user/updateUser',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除用户
export async function deleteUserApi(data) {
  const Req = new ReqClient({
    url: '/api/user/deleteUser',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 访问记录
export async function queryLogApi(data) {
  const Req = new ReqClient({
    url: '/api/user/queryLog',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 管家账号回显已有账号
export async function queryChannelManager(data) {
  const Req = new ReqClient({
    url: '/api/user/queryChannelManager',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 管家账号 账号添加 下拉框查询
export async function queryAllChannelManager(data) {
  const Req = new ReqClient({
    url: '/api/user/queryAllChannelManager',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 提交管家账号管理渠道账号
export async function updatemanager(data) {
  const Req = new ReqClient({
    url: '/api/user/updatemanager',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询历史用户名
export async function queryAllUsers(data) {
  const Req = new ReqClient({
    url: '/api/user/queryAllUsers',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑数据权限获取角色数据
export async function queryAllRole(data) {
  const Req = new ReqClient({
    url: '/api/role/queryAllRole',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * 权限配置模块
 */
// 查询权限列表
export async function queryAllRoleByDept(data) {
  const Req = new ReqClient({
    url: '/api/role/queryAllRoleByDept',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除功能角色
export async function deleteRole(data) {
  const Req = new ReqClient({
    url: '/api/role/deleteRole',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加功能角色
export async function addRole(data) {
  const Req = new ReqClient({
    url: '/api/role/addRole',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 编辑功能角色
export async function updateRole(data) {
  const Req = new ReqClient({
    url: '/api/role/updateRole',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    console.log(e)
    Req.handleError(e)
    return false
  }
}

// 查询弹窗权限配置数据
export async function queryRoleAuth(data) {
  const Req = new ReqClient({
    url: '/api/role/queryRoleAuth',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询弹窗权限配置左侧菜单
export async function queryMenuTreeByAuth(data) {
  const Req = new ReqClient({
    url: '/api/role/queryMenuTreeByAuth',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 应用组表格数据分页查询
 * @param {*} data {keyword: '', pageIndex: 1, pageSize: 30]}
 */
export async function queryAppGroupsByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/appGroup/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 新增编辑应用组
 * @param {*} data {groupId: 123, groupName: '', gameIds: []}
 */
export async function addUpdateAppGroup(data) {
  const Req = new ReqClient({
    url: '/api/ptom/appGroup/addOrModify',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 删除应用组
 * @param {*} data {id: 123}
 */
export async function removeAppGroup(data) {
  const Req = new ReqClient({
    url: '/api/ptom/appGroup/delete',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 验证账号是否可用
 * @param {*} data {adAccountList: [], mediaId: 0}
 */
export async function checkAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/checkAccount',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 查询所有账号
 * @param {*} data {adAccountList: [], mediaId: 0}
 */
export async function queryAccountPageNew(data) {
  const Req = new ReqClient({
    url: '/api/ptom/adAccount/queryAccountPageNew',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 再归因配置
 * @param {*} data
 */
export async function getReAttributionConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/reAttribution/getConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 更新再归因配置
 * @param {*} data
 */
export async function updateReAttributionConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/reAttribution/updateConfig',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
